import React from 'react';
import DescargaFactura from './components/DescargaFactura.jsx';
import MainLayout from './Layouts/MainLayout.jsx';

function App() {
  return (
    <div className="App">
      <MainLayout>
      <DescargaFactura />
      </MainLayout>
    </div>
  );
}

export default App;
